export const ItiString = {
	Empty: "",
	NA: "N/A",
	capitalizeFirstLetter(text: string | undefined): string {
		if (!text) return "";
		return text.charAt(0).toUpperCase() + text.slice(1);
	},
	booleanToString(value: boolean): string {
		return value ? "Sí" : "No";
	},
	isNullOrWhiteSpace(value: string | null | undefined): boolean {
		try {
			if (value == null || value === "undefined") {
				return true;
			}

			return value.toString().replace(/\s/g, "").length < 1;
		} catch (e) {
			return false;
		}
	},
	formatCamelCase(value: string): string {
		let result = value.replace(/([A-Z]+)/g, " $1");
		if (result.indexOf(" ") === 0) {
			result = result.substring(1, result.length);
		}
		return result;
	},
	formatPascalCase(value: string): string {
		const words = value.split(/\s+/);

		const pascalCaseString = words
			.map((word) => word.charAt(0).toUpperCase() + word.slice(1))
			.join("");

		return pascalCaseString;
	},
	splitComaToBr(value: string): string {
		return value.replace(/(,+)/g, "<br/>");
	},
	cleanCharacter(value: string, char: string): string {
		if (value == null) {
			return value;
		}
		if (value.indexOf(char) === -1) {
			return value;
		}
		const _value = value.replace(char, "");
		return ItiString.cleanCharacter(_value, char);
	},
	countChar(value: string, char: string): number {
		return (value.match(new RegExp(char, "g")) || []).length;
	},
	format(format: any, ...args: any): string {
		try {
			return format
				.toString()
				.replace(/{(\d+(:\w*)?)}/g, (match: any, i: any) => {
					const s = match.split(":");
					let index = i;
					let finalMatch = match;
					if (s.length > 1) {
						index = i[0];
						finalMatch = s[1].replace("}", "");
					}

					const arg = ItiString.parsePattern(finalMatch, args[index]);
					return typeof arg !== "undefined" && arg != null
						? arg
						: ItiString.Empty;
				});
		} catch (e) {
			return ItiString.Empty;
		}
	},
	parsePattern(match: any, arg: any): string {
		if (arg == null || arg === undefined) {
			return arg;
		}

		if (match === "L") {
			return arg.toLowerCase();
		}
		if (match === "U") {
			return arg.toUpperCase();
		}
		if (match === "d") {
			return ItiString.formatDate(arg);
		}
		if (match === "s") {
			return ItiString.formatS(arg);
		}
		if (match === "n") {
			return ItiString.formatN(arg);
		}
		return arg;
	},

	/**
	 * Formatea una fecha en formato ISO 8601 (YYYY-MM-DDTHH:mm:ss.sssZ) a un formato personalizado (DD.MM.YYYY).
	 *
	 * @param {any} arg - La fecha en formato ISO 8601 que se va a formatear.
	 * @return {string} La fecha formateada en el formato personalizado (DD.MM.YYYY).
	 */
	formatDate(arg: any): string {
		const splitted = arg.split("-");
		if (splitted.length <= 1) {
			return arg;
		}
		let day = splitted[splitted.length - 1];
		const month = splitted[splitted.length - 2];
		const year = splitted[splitted.length - 3];
		day = day.split("T")[0];
		day = day.split(" ")[0];

		return `${day}.${month}.${year}`;
	},

	/**
	 * Formatea una cadena de fecha y hora en formato personalizado (S) a formato ISO 8601 (YYYY-MM-DDTHH:mm:ss).
	 *
	 * @param {any} arg - La cadena de fecha y hora en formato personalizado que se va a formatear.
	 * @return {string} La cadena formateada en formato ISO 8601 (YYYY-MM-DDTHH:mm:ss).
	 */
	formatS(arg: any): string {
		const splitted = arg.replace(",", "").split(".");
		if (splitted.length <= 1) {
			return arg;
		}
		let time = splitted[splitted.length - 1].split(" ");
		if (time.length > 1) {
			time = time[time.length - 1];
		}

		const year = splitted[splitted.length - 1].split(" ")[0];
		const month = splitted[splitted.length - 2];
		const day = splitted[splitted.length - 3];
		let finalDate = arg;

		finalDate = `${year}-${month}-${day}`;
		if (time.length > 1) {
			finalDate += `T${time}`;
		} else {
			finalDate += "T00:00:00";
		}
		return finalDate;
	},

	/**
	 * Formatea un número añadiendo puntos como separadores de miles.
	 *
	 * @param {any} arg - El número que se va a formatear.
	 * @return {string} El número formateado con puntos como separadores de miles.
	 */
	formatN(arg: any): string {
		if (Number.isNaN(Number.parseInt(arg, 10)) || arg.length <= 3) {
			return arg;
		}
		const stringArg = arg.toString();
		const mod = stringArg.length % 3;
		let output = mod > 0 ? stringArg.substring(0, mod) : ItiString.Empty;
		for (let i = 0; i < Math.floor(stringArg.length / 3); i++) {
			if (mod === 0 && i === 0) {
				output += stringArg.substring(mod + 3 * i, mod + 3 * i + 3);
			} else {
				output += `.${stringArg.substring(mod + 3 * i, mod + 3 * i + 3)}`;
			}
		}
		return output;
	},
	valueOrDefault(value: string, defaultValue: string): string {
		return ItiString.isNullOrWhiteSpace(value) ? defaultValue : value;
	},
};
